module.exports = {"320324001":"睢城街道","320324002":"金城街道","320324003":"睢河街道","320324102":"王集镇","320324103":"双沟镇","320324104":"岚山镇","320324105":"李集镇","320324106":"桃园镇","320324107":"官山镇","320324108":"高作镇","320324109":"沙集镇","320324110":"凌城镇","320324111":"邱集镇","320324112":"古邳镇","320324113":"姚集镇","320324114":"魏集镇","320324115":"梁集镇","320324116":"庆安镇","320324401":"经济开发区","320324405":"空港经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320324.json
// module id = 791
// module chunks = 0